"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconWrapper",
  class: "pl-i1kmq36b"
});
const NavIcon = exports.NavIcon = "pl-n1k2jhhj";

/**
 * Icons Component.
 *
 * @param {Object} props React props
 * @param {String} props.icon Icon String
 * @returns {React.ReactElement} Icons Component
 * @public
 */

function Icons({
  icon,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(IconWrapper, (0, _extends2.default)({
    "data-partial": "highlight-primary"
  }, rest), /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: icon
  }));
}
var _default = exports.default = Icons;
Icons.propTypes = {
  icon: _propTypes.default.string
};